<template>
    <v-footer app color="#25476A" class="white--text">
        <span class="overline">British Publishing House Ltd.</span>
        <v-spacer></v-spacer>
        <span class="overline">&copy; All rights reserved</span>
    </v-footer>
</template>

<script>
    export default {
        name: "Footer",

    };
</script>
